import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { BaseObject } from './BaseObject';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
*/

export const MeetingAccountSource = {
    missionOrganization: 0,
    meetingOrganization: 1,
    meetingAccount: 2,
};

export const MeetingCertifierSource = {
    missionOrganization: 0,
    meetingOrganization: 1,
};

export const MeetingType = {
    regular: 0,
    other: 1,
};

export class Meeting extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);

            this.Date = utility.parseDate(this.Date);
        }
    }

    /**
     * 
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        this.Organization = ctx.getOrganization(this.OrganizationId);
        this.WageCalculation = ctx.getWageCalculation(this.WageCalculationId);
    }

    toJSON() {
        var ret = super.toJSON();
        ret.OrganizationId = BaseObject.withRelated(ret, 'Organization');
        ret.WageCalculationId = BaseObject.withRelated(ret, 'WageCalculation');
        return ret;
    }

    clone() {
        var src = _.clone(this);
        src.Organization = null;
        src.WageCalculation = null;

        var ret = _.cloneDeep(src);
        ret.Organization = this.Organization;
        ret.WageCalculation = this.WageCalculation;

        return ret;
    }
}

export class MeetingPolitikerInfo {
    /**
     * 
     * @param {any} result
     * @param {ResponseContext} context
     */
    constructor(result, context) {
        this.MeetingId = result.MeetingId;
        this.Meeting = context.getMeeting(result.MeetingId);
        this.ClaimCount = result.ClaimCount;
        this.FirstClaimTimestamp = utility.parseDate(result.FirstClaimTimestamp);
        this.TimeReportCount = result.TimeReportCount;
        this.FirstTimeReportTimestamp = utility.parseDate(result.FirstTimeReportTimestamp);
        this.IncompleteRemunerationCount = result.IncompleteRemunerationCount;

        this.issueCount = this.ClaimCount + this.TimeReportCount + this.IncompleteRemunerationCount;

        if (this.FirstClaimTimestamp == null) {
            this.firstTimestamp = this.FirstTimeReportTimestamp;
        } else if (this.FirstTimeReportTimestamp == null) {
            this.firstTimestamp = this.FirstClaimTimestamp;
        } else {
            this.firstTimestamp = new Date(Math.min(this.FirstClaimTimestamp.getTime(), this.FirstTimeReportTimestamp.getTime()));
        }
    }

    /**
     * 
     * @param {any} result
     * @param {ResponseContext} context
     */
    static mapResponse(result, context) {
        return new MeetingPolitikerInfo(result, context);
    }
}

export class MeetingPendingInfo {
    /**
     * 
     * @param {any} result
     * @param {ResponseContext} context
     */
    constructor(result, context) {
        this.MeetingId = result.MeetingId;
        this.Meeting = context.getMeeting(result.MeetingId);
        this.Count = result.Count;
        this.FirstTimestamp = utility.parseDate(result.FirstTimestamp);
    }
    
    /**
     * 
     * @param {any} result
     * @param {ResponseContext} context
     */
    static mapResponse(result, context) {
        return new MeetingPendingInfo(result, context);
    }
}